var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection3ArrowRight = function SvgSection3ArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.061 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.94 8 9.47 3.53l1.06-1.06L16.06 8l-5.53 5.53-1.06-1.06L13.94 8Z",
    fill: "#1D1E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.75H1v-1.5h14v1.5Z",
    fill: "#1D1E1F"
  })));
};
export default SvgSection3ArrowRight;